// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__IjunX","title":"Images90_title__2JnqJ","images":"Images90_images__1W6Y3"};